import { render, staticRenderFns } from "./ModalContentVirtualMemberDelete.vue?vue&type=template&id=50e2fa26&scoped=true&"
import script from "./ModalContentVirtualMemberDelete.vue?vue&type=script&lang=js&"
export * from "./ModalContentVirtualMemberDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentVirtualMemberDelete.vue?vue&type=style&index=0&id=50e2fa26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e2fa26",
  null
  
)

export default component.exports